/**
 * Nome da mostrare per l'utente autenticato. Con il login Microsoft Entra ID il `sub` del JWT è
 * l'object ID (un GUID): si preferiscono nome ed email, ripiegando su `sub` (IdP di sviluppo,
 * admin locale senza nome).
 */
import type { JwtClaims } from './types.js';

export function displayName(claims: JwtClaims): string {
  for (const key of ['name', 'email', 'preferred_username'] as const) {
    const v = claims[key];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }
  return claims.sub;
}
